import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { PartnersComponent } from '../partners/partners';

@Component({
  selector: 'app-partners-section',
  standalone: true,
  imports: [TranslocoModule, PartnersComponent],
  template: `
    <section
      id="partners"
      class="relative overflow-hidden py-14"
      style="
        background: var(--theme-bg-alt);
        border-top: 1px solid rgba(255,255,255,0.05);
        border-bottom: 1px solid rgba(255,255,255,0.05);
      "
      aria-label="Our partners"
      *transloco="let t"
    >
      <div class="dot-accent-tr" aria-hidden="true"></div>

      <p
        class="text-center text-xs uppercase tracking-widest font-semibold mb-8 reveal"
        style="color:var(--theme-text-muted)"
      >
        {{ t('ourPartners') }}
      </p>
      <app-partners></app-partners>
    </section>
  `,
  styles: [`:host { display: block; }`],
})
export class PartnersSectionComponent {}
